module.exports = __webpack_public_path__ + "img/Quizz_0001_sis-nervoso.bd726786.png";